module.exports = __webpack_public_path__ + "media/customizations/regencyatmontaine/back-1bedbe840724493696c4a66ea58c72ae.jpg";